import { NgModule } from '@angular/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../shared/shared.module';
import { CycleEditorModalComponent } from './cycle-editor-modal/cycle-editor-modal';
import { CyclesPage } from './cycles';

@NgModule({
  declarations: [CyclesPage, CycleEditorModalComponent],
  imports: [IonicPageModule.forChild(CyclesPage), SharedModule, GridModule],
  entryComponents: [CycleEditorModalComponent]
})
export class CyclesPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/cycles/cycles.module.ts